import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const DELETE_REPORT_PACKAGE_FAVORITE = "DELETE_REPORT_PACKAGE_FAVORITE";

export const service = async (reportUserAssocId) => {
  const options: object = {
    url: `/api/ReportPackage/DeleteReportPackageFavorite/` + reportUserAssocId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_REPORT_PACKAGE_FAVORITE, service, mock);
